import { Tag, Tooltip } from '@faceup/ui-base'

type ReportStatusTagProps = {
  color: string
  name: string
}

export const ReportStatusTag = ({ color, name }: ReportStatusTagProps) => {
  return (
    <Tooltip title={name}>
      <Tag
        color={color}
        data-test='report-info-status'
        className='inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap align-middle'
      >
        {name}
      </Tag>
    </Tooltip>
  )
}
